// chat-preview.ts — the sidebar hover preview of a chat (SAY-1806, after Open
// WebUI's LinkPreview): which transcript rows the card shows and how it labels
// them. Pure; ChatHoverPreview.svelte fetches + renders.
import type { TranscriptRow } from './chat-search';

/** How many rows the card shows — the END of the conversation, newest last. */
export const PREVIEW_MAX_ROWS = 6;
/** One row is cut to this many characters so a long answer can't fill the card. */
export const PREVIEW_ROW_CHARS = 280;

export function previewTail(
	rows: TranscriptRow[],
	max: number = PREVIEW_MAX_ROWS,
	chars: number = PREVIEW_ROW_CHARS,
): TranscriptRow[] {
	const tail = max > 0 ? rows.slice(-max) : [];
	return tail.map((r) => (r.text.length > chars ? { ...r, text: r.text.slice(0, chars).trimEnd() + '…' } : r));
}

export function messageCountLabel(n: number): string {
	return `${n} ${n === 1 ? 'message' : 'messages'}`;
}

export function formatPreviewTime(ts: number): string {
	if (!ts) return '';
	return new Date(ts).toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
